import { render, staticRenderFns } from "./UserChart.vue?vue&type=template&id=6da11c71&"
import script from "./UserChart.vue?vue&type=script&lang=js&"
export * from "./UserChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports